import apollo from 'apollo';

import { createNormalizedMap, handleFetchError } from 'action-utils';
import {
  allInstalledAppsStatusQuery,
  allInstalledAppsStatusWithTilesQuery
} from 'queries';
import { AsyncActionHandler } from 'action-handler';
import { multiReducer as permissionsReducer } from 'actions/registry/update-permissions';
import { updatePendingFromInstalledReducer } from 'actions/registry/set-pending-app-install-status';

const stateProp = 'installedStatus';

export const reducer = (state, { entries, tileStatuses }) => {
  const installedApps = {
    ...createNormalizedMap(entries, state.installedApps, 'appId')
  };

  const installedTiles = {
    ...createNormalizedMap(tileStatuses, state.installedApps, 'tileId')
  };

  return {
    ...permissionsReducer(state, { entries }),
    ...updatePendingFromInstalledReducer(state, installedApps),
    [stateProp]: {
      entries,
      tileStatuses
    },
    installedApps,
    installedTiles
  };
};

export default new AsyncActionHandler({
  name: 'fetch_installed_apps_status',
  stateProp,
  defaultState: {
    installedApps: {}
  },
  handler() {
    return async (_, getState) => {
      const {
        features: { flags }
      } = getState().registry;

      let installedApps;
      let apolloQuery = allInstalledAppsStatusQuery;

      if (flags.enable_tiles) {
        apolloQuery = allInstalledAppsStatusWithTilesQuery;
      }
      try {
        const { data } = await apollo.query({
          query: apolloQuery,
          fetchPolicy: 'network-only'
        });
        installedApps = data.installedApps;
      } catch (error) {
        return handleFetchError(error);
      }

      const { appStatuses, tileStatuses } = installedApps;
      return {
        entries: appStatuses,
        tileStatuses
      };
    };
  },
  reduce: reducer
});
